let mapaOrquideas = {};
let mapaRequired = {};

function productPromise(handle) {
  return fetch(
    "https://set-the-table-mexico.myshopify.com/api/2021-04/graphql.json",
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": "6e7630e3380ab2256e16d18878ffa471",
      },
      body: `
    {
      productByHandle(handle: "${handle}") {
        title
        variants(first: 100) {
          edges {
            node {
              title
              quantityAvailable
            }
          }
        }
      }
    }
  `,
    }
  ).then((json) => json.json());
}

function blockCart(llave, diferencia) {
  const errorText = document.querySelector(".js-error-orquidea");
  const botonCarrito = document.querySelector(".js-chackout__button");

  if (llave) {
    errorText.textContent = `No contamos con suficientes orquideas color ${llave}, elimina ${
      diferencia * -1
    } para proseguir con tu compra.`;
    errorText.style.display = "block";
  }

  botonCarrito.disabled = true;
  botonCarrito.textContent = "Productos no Disponibles";
}

function unblockCart() {
  const errorText = document.querySelector(".js-error-orquidea");
  const botonCarrito = document.querySelector(".js-chackout__button");

  errorText.textContent = ``;
  errorText.style.display = "none";

  botonCarrito.disabled = false;
  botonCarrito.textContent = "Comprar Ahora";
}

window.addEventListener("load", function () {
  const productos = document.querySelectorAll(".c-card-cart");
  let orchideasArray = [];
  errorsArray = [];

  productos.forEach((producto) => {
    const prodType = producto.dataset.itemType;

    if (prodType === "Orquideas") {
      orchideasArray.push({
        handle: producto.dataset.itemHandle,
        quantity:
          parseInt(
            producto.dataset.itemTags
              .split(",")
              .find((tag) => tag.includes("Num:"))
              .split(": ")[1]
              .split("/")[0]
          ) * parseInt(producto.dataset.itemQuantity),
        size: producto.dataset.itemTags
          .split(",")
          .find((tag) => tag.includes("Num:"))
          .split(": ")[1]
          .split("/")[1],
        variant: producto.dataset.itemVariant,
      });
    }
  });

  if (orchideasArray.length > 0) {
    blockCart();
    let promiseArr = [
      productPromise("orquidea"),
      productPromise("orquidea-mini"),
    ];

    Promise.all(promiseArr)
      .then((resp) => {
        resp.forEach((flor) => {
          const title = flor.data.productByHandle.title;
          const variants = {};

          flor.data.productByHandle.variants.edges.forEach((variant) => {
            variants[variant.node.title] = variant.node.quantityAvailable;
          });

          mapaOrquideas[title] = variants;
        });

        orchideasArray.forEach((orchi) => {
          const newMap = {};
          const tamano = orchi.size === "mini" ? "orquidea mini" : "orquidea";
          const variante = orchi.variant.includes("/")
            ? orchi.variant.split("/")[1].trim()
            : orchi.variant;
          newMap[variante] = parseInt(orchi.quantity);

          if (mapaRequired[tamano]) {
            mapaRequired[tamano][variante] =
              (mapaRequired[tamano][variante]
                ? mapaRequired[tamano][variante]
                : 0) + newMap[variante];
          } else {
            mapaRequired[tamano] = newMap;
          }
        });

        console.log("Inventario: ", mapaOrquideas);
        console.log("Requeridas: ", mapaRequired);

        if (mapaRequired["orquidea mini"]) {
          Object.keys(mapaRequired["orquidea mini"]).forEach((llave) => {
            const diferencia =
              mapaOrquideas["orquidea mini"][llave] -
              mapaRequired["orquidea mini"][llave];

            console.log(`${llave}: ${diferencia}`);

            if (diferencia < 0) {
              blockCart(llave, diferencia);
            } else {
              unblockCart();
            }
          });
        } else if (mapaRequired["orquidea"]) {
          Object.keys(mapaRequired["orquidea"]).forEach((llave) => {
            const diferencia =
              mapaOrquideas["orquidea"][llave] -
              mapaRequired["orquidea"][llave];

            console.log(`${llave}: ${diferencia}`);

            if (diferencia < 0) {
              blockCart(llave, diferencia);
            } else {
              unblockCart();
            }
          });
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      });
  } else {
    unblockCart();
  }
});
